import React, { useEffect, useState } from 'react';
import './Sucursales.css';
import baseURL from '../url';

export default function Sucursales() {
    const [sucursales, setSucursales] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarSucursales();
    }, []);

    const cargarSucursales = () => {
        fetch(`${baseURL}/sucursalesGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSucursales(data.sucursales || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar sucursales:', error);
                setLoading(false);
            });
    };

    // No mostrar nada si no hay sucursales
    if (loading || !sucursales || sucursales.length === 0) {
        return null;
    }

    return (
        <section className='sucursalesSection'>
            <div className='sucursalesContainer'>
                <h2 className='sucursalesTitle'>Sucursales</h2>
                <div className='sucursalesGrid'>
                    {sucursales.map(sucursal => (
                        <a
                            key={sucursal.idSucursal}
                            href={sucursal.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className='btnSucursal'
                        >
                            {sucursal.nombre}
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}



